// extracted by mini-css-extract-plugin
export default {"icon":"UiIcon_icon"};